import { actions } from './slice';
import {
  getPaginatedRequests,
  getAccountData,
  getPatientsData,
  getPatientEcgCaptures,
  updateRequest,
  getAccountNotificationSettings,
} from './actions';

const allActions = {
  ...actions,
  getAccountNotificationSettings,
  getPaginatedRequests,
  getAccountData,
  getPatientsData,
  getPatientEcgCaptures,
  updateRequest,
};

export { allActions as requestsActions };
export { reducer as requestReducer } from './slice';
